/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Transparent_Background_LabelInputs */

const en_image_export_transparent_background_label = /** @type {(inputs: Image_Export_Transparent_Background_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparent Background (Alpha)`)
};

const fr_image_export_transparent_background_label = /** @type {(inputs: Image_Export_Transparent_Background_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arriere-plan transparent (Alpha)`)
};

const de_image_export_transparent_background_label = /** @type {(inputs: Image_Export_Transparent_Background_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparenter Hintergrund (Alpha)`)
};

const it_image_export_transparent_background_label = /** @type {(inputs: Image_Export_Transparent_Background_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfondo trasparente (Alfa)`)
};

const ru_image_export_transparent_background_label = /** @type {(inputs: Image_Export_Transparent_Background_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачный фон (альфа-канал)`)
};

const es_image_export_transparent_background_label = /** @type {(inputs: Image_Export_Transparent_Background_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondo transparente (alfa)`)
};

const zh_cn2_image_export_transparent_background_label = /** @type {(inputs: Image_Export_Transparent_Background_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透明背景（Alpha通道）`)
};

const ja_image_export_transparent_background_label = /** @type {(inputs: Image_Export_Transparent_Background_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透明な背景（アルファ）`)
};

const hi_image_export_transparent_background_label = /** @type {(inputs: Image_Export_Transparent_Background_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पारदर्शी पृष्ठभूमि (अल्फा)`)
};

const pt_pt2_image_export_transparent_background_label = /** @type {(inputs: Image_Export_Transparent_Background_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundo transparente (alfa)`)
};

/**
* | output |
* | --- |
* | "Transparent Background (Alpha)" |
*
* @param {Image_Export_Transparent_Background_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_transparent_background_label = /** @type {((inputs?: Image_Export_Transparent_Background_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Transparent_Background_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_transparent_background_label(inputs)
	if (locale === "de") return de_image_export_transparent_background_label(inputs)
	if (locale === "it") return it_image_export_transparent_background_label(inputs)
	if (locale === "ru") return ru_image_export_transparent_background_label(inputs)
	if (locale === "es") return es_image_export_transparent_background_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_transparent_background_label(inputs)
	if (locale === "ja") return ja_image_export_transparent_background_label(inputs)
	if (locale === "hi") return hi_image_export_transparent_background_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_transparent_background_label(inputs)
	return en_image_export_transparent_background_label(inputs)
});